/* Filter pills — level-2 in-place filtering via the Section Rendering API,
   level-1 hover prefetch. plans/filter-build-2026-06-11 (phase 4 UX).
   Level 1 pills are real navigation (full page load) per Audrey-approved behavior
   2026-06-12; only level-2 toggles filter in place.
   Pills stay plain <a> links: no JS = normal navigation. */
(function () {
  'use strict';

  var GRID_SELECTOR = '#ProductGridContainer';
  var NAV_SELECTOR = '.fp-pills';
  var controller = null;

  function sectionKeyOf(el) {
    var s = el && el.closest('.shopify-section');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }

  function swapFromSectionHtml(html, selector) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    return true;
  }

  function setLoading(on) {
    [GRID_SELECTOR, NAV_SELECTOR].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      el.classList.toggle('fp-loading', on);
      if (sel === GRID_SELECTOR) el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }

  function load(url, push) {
    var grid = document.querySelector(GRID_SELECTOR);
    var nav = document.querySelector(NAV_SELECTOR);
    var gridKey = sectionKeyOf(grid);
    var navKey = sectionKeyOf(nav);
    if (!gridKey || !navKey) {
      window.location.href = url;
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    setLoading(true);
    var u = new URL(url, window.location.origin);
    u.searchParams.set('sections', gridKey + ',' + navKey);
    fetch(u.toString(), { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var ok = swapFromSectionHtml(data[gridKey], GRID_SELECTOR);
        swapFromSectionHtml(data[navKey], NAV_SELECTOR);
        if (!ok) {
          window.location.href = url;
          return;
        }
        if (push) history.pushState({ fpPills: true }, '', url);
        document.dispatchEvent(new CustomEvent('fp-pills:updated', { detail: { url: url } }));
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') window.location.href = url;
      })
      .finally(function () {
        setLoading(false);
      });
  }

  // Filter pills load in place: all level-2 pills, plus explicit toggles on any
  // level (the Unscented concern pill on category pages). Level-1 nav pills are
  // real navigation and are NOT intercepted. Delegated — survives swaps.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var a = e.target.closest('.fp-pills[data-fp-level="2"] a.fp-pill, .fp-pills a.fp-pill--toggle');
    if (!a) return;
    e.preventDefault();
    load(a.getAttribute('href'), true);
  });

  // Back/forward restores any in-place filter state without a full reload.
  window.addEventListener('popstate', function () {
    if (document.querySelector('.fp-pills')) {
      load(window.location.href, false);
    }
  });

  // Level 1: pills are real navigation — prefetch on intent so it feels instant.
  function prefetch(e) {
    var a = e.target.closest('.fp-pills[data-fp-level="1"] a.fp-pill');
    if (!a || a.dataset.fpPrefetched) return;
    a.dataset.fpPrefetched = '1';
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = a.href;
    document.head.appendChild(link);
  }
  document.addEventListener('mouseover', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });
})();
